export default __webpack_public_path__ + "locales/tr/VersionHistory.json?hash=f224fe4d4602c84554c87639fe6d2c8c";